<script setup lang="ts">
const props = defineProps<{ title: string }>();
</script>

<template>
    <header class="w-screen h-40 bg-linear-to-r from-[#021B79] to-[#0166FF] relative">
        <div class="absolute w-full h-full bg-[url('/img/networkImage.webp')]" />
        <div class="container h-full flex items-center justify-between relative z-1">
            <div class="flex items-center text-4xl font-extrabold text-white">
                <NuxtImg
                width="70"
                height="70"
                src="/img/white-logo.webp"
                alt="نواتل"
                />
                <span class="hidden lg:block">نواتل</span>
            </div>
            <p class="text-[#CCEBFF] text-[1rem] md:text-[1.4rem] lg:text-[2rem] font-bold text-center">{{ props.title }}</p>
            <NuxtImg
                width="150"
                class="w-25 lg:w-37.5"
                src="/img/fanteziCloud.webp"
                alt="ابر"
            />
        </div>
    </header>
</template>